import { IconButton, Typography } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import styles from "./styles.less";
import { securityLogoUrl } from "../../settings";
import { ArrowBack } from "@material-ui/icons";
import { useHistory, useParams } from "react-router";

export function MobileAppBar({ route, onHome }) {
  const history = useHistory();
  const { id } = useParams();
  const { assetData, assetLoader } = useSelector((state) => ({
    assetData: state.asset.assetData || {},
    assetLoader: state.asset.assetLoader,
  }));
  const assetRef = useRef(
    route.title.toLowerCase() === "asset" ||
      route.title.toLowerCase() === "publicinstrument"
  );
  const [state, setState] = useState({
    isPublicInstrument: false,
    title: route.title,
  });

  const onBack = () => {
    if (assetRef.current) {
      onHome();
    } else {
      history.goBack();
    }
  };

  useEffect(() => {
    if (
      assetRef.current &&
      !assetLoader &&
      assetData.name &&
      id == assetData.id
    ) {
      setState((prev) => ({
        ...prev,
        title: assetData.name,
        isPublicInstrument: !!assetData.pi_id,
      }));
    }
  }, [assetData, assetLoader, id]);

  return (
    <>
      <div className={styles.headActionWrapper}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={onBack}
        >
          <ArrowBack />
        </IconButton>
        <div className={styles.logoWrapper}>
          {state.isPublicInstrument && (
            <div className={styles.imgWrapper}>
              <img
                src={
                  securityLogoUrl + `${assetData?.logo || "placeholder.svg"}`
                }
                alt="alt"
                className={styles.securityLogo}
              />
            </div>
          )}
          <Typography
            variant="h6"
            color="inherit"
            style={{ marginLeft: "1rem" }}
          >
            {state.title}
          </Typography>
        </div>
      </div>
    </>
  );
}
